<template>
    <el-drawer
            :wrapperClosable="false"
            destroy-on-close
            v-bind="$attrs"
            v-on="$listeners"
            :custom-class="'drawer-form-layout-wrap ' + $attrs.class">
        <div class="content-wrap">
            <slot></slot>
        </div>

        <div class="footer-button-wrap">
            <slot name="footer"></slot>
        </div>
    </el-drawer>
</template>

<script>
    export default JBoot({
        registryName: 'DrawerFormLayout'
    }).build();
</script>

<style lang="scss">
    .drawer-form-layout-wrap{
        & >.el-drawer__header{
            background-color: #004ec3 !important;
            padding: 10px 15px !important;
            margin-bottom: 0 !important;
            color: #333333 !important;
        }
        & > .el-drawer__body{
            height: 100%;
            width: 100%;
            overflow: hidden;
            & > .content-wrap{
                width: 100%;
                height: calc(100% - 50px);
                overflow-y: auto;
                padding: 10px;
            }
            & > .footer-button-wrap{
                padding-top: 10px;
                width: 100%;
                text-align: center;
                border-top: 1px solid #ececec;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/DrawerFormLayout.vue